"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _excluded = ["colorType", "circleColor", "arrowColor"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var CtaArrow = function CtaArrow(_ref) {
  var colorType = _ref.colorType,
    _ref$circleColor = _ref.circleColor,
    circleColor = _ref$circleColor === void 0 ? '#FFC13F' : _ref$circleColor,
    _ref$arrowColor = _ref.arrowColor,
    arrowColor = _ref$arrowColor === void 0 ? '#192128' : _ref$arrowColor,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    width: 72,
    height: 24,
    viewBox: "0 0 72 24"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M0 12.5h50V11H0z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    fill: circleColor,
    cx: 60,
    cy: 12,
    r: 12
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M58.25 11v1.5H48.006a7.927 7.927 0 01.084-1.5h10.16z",
    fill: arrowColor
  })), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M60 17.025l1.02.975 5.769-5.513a.668.668 0 000-.974L61.019 6 60 6.975 65.26 12 60 17.025z",
    fill: arrowColor,
    fillRule: "nonzero"
  })));
};
CtaArrow.propTypes = {
  arrowColor: _propTypes["default"].string,
  circleColor: _propTypes["default"].string
};
var _default = exports["default"] = CtaArrow;